import { useBlobUrl } from "./common";

export const Avatar = ({ avatarId, name, className = "avatar", testId }) => {
  const { url } = useBlobUrl(avatarId ? `/avatars/${avatarId}` : null);
  return (
    <span className={`${className} avatar-img`} data-testid={testId}>
      {url ? <img src={url} alt={name || "avatar"} /> : (name || "?")[0]?.toUpperCase()}
    </span>
  );
};
